import * as React from "react";
import styled from "styled-components";
import { Color } from "@glossy/colors";

const Separator = styled.div`
  font-size: 12px;
`;

const Spacer = styled.div`
  width: 50%;
  height: 60px;
  display: inline-block;
  border-right: 2px solid ${Color.Nobel};
  vertical-align: middle;
`;

const Word = styled.div`
  background: ${Color.White};
  vertical-align: middle;
  display: inline-block;
  text-transform: uppercase;
  border-radius: 20px;
  border: 2px solid ${Color.Nobel};
  padding: 6px;
  transform: translateX(-50%);
`;

const QueriesInfoSeparatorModal = ({ label }: { label: string }) => (
  <Separator>
    <Spacer />
    <Word>{label}</Word>
  </Separator>
);

export default QueriesInfoSeparatorModal;
